import { Arrange, Icon, SvgAlertTriangle } from '@loomhq/lens';
import React from 'react';

import SidebarCtaContainer from './sidebar-cta-container';
import { FadeCallout } from './fade-callout';

export function DevToolCallout({ displayMode, children }) {
  return (
    <>
      <FadeCallout
        className="absolute bottom:small"
        visible={displayMode === 'COLLAPSED'}
        width="collapsed"
      >
        <SidebarCtaContainer
          className="bottom:small"
          color="var(--lns-color-background)"
          backgroundColor="var(--lns-color-body)"
          borderColor="var(--lns-color-backgroundHover)"
          width="var(--navSidebarInnerWidthCollapsed)"
        >
          <Arrange alignItems="start" gap="small">
            <Icon color="background" icon={<SvgAlertTriangle />} />
          </Arrange>
        </SidebarCtaContainer>
      </FadeCallout>
      <FadeCallout
        className="absolute bottom:small"
        visible={displayMode !== 'COLLAPSED'}
        width="expanded"
      >
        <SidebarCtaContainer
          className="bottom:small"
          color="var(--lns-color-background)"
          backgroundColor="var(--lns-color-body)"
          borderColor="var(--lns-color-backgroundHover)"
          width="var(--navSidebarInnerWidthExpanded)"
        >
          <Arrange alignItems="start" gap="small">
            <Icon color="background" icon={<SvgAlertTriangle />} />
            {children}
          </Arrange>
        </SidebarCtaContainer>
      </FadeCallout>
    </>
  );
}
